import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-primary-100">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-clapperboard-line text-xl" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">美国伦理片</span>
            </div>
            <p className="text-sm leading-7 text-primary-200 max-w-md">
              专注收录与介绍美国伦理题材电影的专业资料站，提供详尽的剧情解析、专业影评与精选推荐，帮助影迷深入了解每一部作品背后的思考。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">站内导航</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="hover:text-accent-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category" className="hover:text-accent-400 transition-colors cursor-pointer">影片分类</Link></li>
              <li><Link to="/special" className="hover:text-accent-400 transition-colors cursor-pointer">影评专题</Link></li>
              <li><Link to="/search" className="hover:text-accent-400 transition-colors cursor-pointer">搜索结果</Link></li>
              <li><Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">题材分类</h4>
            <ul className="space-y-2.5 text-sm">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link to={`/category?cat=${c.slug}`} className="hover:text-accent-400 transition-colors cursor-pointer">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-primary-300">
          <p>© 2026 美国伦理片 · 本站内容均为演示数据，仅供前端展示与学习交流使用。</p>
          <p>所有影片信息、评分与影评均为示例内容，不涉及真实播放或下载服务。</p>
        </div>
      </div>
    </footer>
  );
}